import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_14194_15645)">
          <path
            d="M10.6667 12C11.0203 12 11.3594 12.1405 11.6095 12.3905C11.8595 12.6406 12 12.9797 12 13.3334C12 12.9797 12.1405 12.6406 12.3905 12.3905C12.6406 12.1405 12.9797 12 13.3333 12C12.9797 12 12.6406 11.8595 12.3905 11.6095C12.1405 11.3594 12 11.0203 12 10.6667C12 11.0203 11.8595 11.3594 11.6095 11.6095C11.3594 11.8595 11.0203 12 10.6667 12ZM10.6667 4.00002C11.0203 4.00002 11.3594 4.1405 11.6095 4.39054C11.8595 4.64059 12 4.97973 12 5.33335C12 4.97973 12.1405 4.64059 12.3905 4.39054C12.6406 4.1405 12.9797 4.00002 13.3333 4.00002C12.9797 4.00002 12.6406 3.85954 12.3905 3.6095C12.1405 3.35945 12 3.02031 12 2.66669C12 3.02031 11.8595 3.35945 11.6095 3.6095C11.3594 3.85954 11.0203 4.00002 10.6667 4.00002ZM6 12C6 10.9392 6.42143 9.92174 7.17157 9.17159C7.92172 8.42145 8.93913 8.00002 10 8.00002C8.93913 8.00002 7.92172 7.57859 7.17157 6.82845C6.42143 6.0783 6 5.06089 6 4.00002C6 5.06089 5.57857 6.0783 4.82843 6.82845C4.07828 7.57859 3.06087 8.00002 2 8.00002C3.06087 8.00002 4.07828 8.42145 4.82843 9.17159C5.57857 9.92174 6 10.9392 6 12Z"
            stroke="#9068FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_14194_15645">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
